import React from "react";
import { useState, useEffect } from "react";

import Loader from "../../UI/loader";
import { CMSPath } from "../../../config/constant";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setGoHome } from "../../action/homeAction";
import ActivityBookingUpdate1 from "./ActivityBookingUpdate1";
import ActivityBookingUpdate2 from "./ActivityBookingUpdate2";
import { sendAnalytics } from "../../../action/homeAction";
import moment from "moment";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";



import { scrollToTop } from "../../../JS/scrollToTop";
import { updateMyActivity } from "../../../action/activityBooking";
 import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { popupOpenClose } from "../../../action/action";





function ActivityBookingUpdate(props) {

    const {t}=props;
    // const [currentPage, setCurrentPage] = useState(1);
    const [isUpdatingReservation, setIsUpdatingReservation] = useState(false);
    const[showLoader, setShowLoader] = useState(false);
    const [additionalGuestCount,setAdditionalGuestCount]=useState('1');

    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });
    let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");


    const handleUpdate = () => {
        setShowLoader(true);

        //API CALLING 

        const payload = {
            "serviceType": "activity",
            "appointmentId": props.updateReservationDetails.id, // Existing activity appointment ID to update
            "confirmationId": props.updateReservationDetails.confirmationId,
            "additionalGuests": Number(additionalGuestCount) // additional guests to add.
        }

        updateMyActivity(payload)
            .then((res) => {
                if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {

                    props.handleUpdateReservation(true, (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg))
                    sendTheAnalytics(true)


                } else {
                    props.handleUpdateReservation(false, (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg))
                    sendTheAnalytics(false)

                }

            })

            .catch(() => {
                props.handleUpdateReservation(false)

            })

            .finally(() => {
                setShowLoader(false)
            })
    }


    const sendTheAnalytics = (isSuccess) => {
        try {

            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                isSuccess ? " UPDATE ACTIVITY - SUCCESS" : "UPDATE ACTIVITY - FAIL",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                0,
                props.guestIsLoggedIn
            );
        } catch (error) {
            return error;
        }

    }

    const handleNext = () => {
        if (!isUpdatingReservation) {
            setIsUpdatingReservation(true);
            setAdditionalGuestCount('1');
            return;
        }
        if (isNaN(Number(additionalGuestCount)) || Number(additionalGuestCount) <= 0) {
            props.popupOpenClose(true, t("activityBooking.invalid_additional_guests"));
            return;
        }
        handleUpdate();

    }
    const handleGoBack = () => {

        props.handleGoBack();
        return;

    }

    useEffect(() => {

        scrollToTop();
    }, [])

    return (

        <>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section class="widgets spa-listing spa-details">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">{isUpdatingReservation ? t("activityBooking.update_reservation_heading") :t("activityBooking.booking_overview")}</div>
                </div>

                <div class="detail-body stay-body">
                    <div class="stay-info">
                        <div class="stay-arrival">
                            <div class="heading">{t("activityBooking.date")}</div>
                            <div class="body">
                                <p>
                                    {moment(new Date(props.updateReservationDetails.date)).format(props.dateFormat.toUpperCase())}



                                </p>
                            </div>
                        </div>
                        <div class="stay-arrival">
                            <div class="heading">{t("activityBooking.time")}</div>
                            <div class="body">
                                <p>{formatLocalTime(
                                    new Date(props.updateReservationDetails.date),
                                    toBool(props.timeFormat)
                                )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="detail-body stay-body">
                            <form>
                                <div class="form-row spa-summary">
                                    <p class="heading">{t("activityBooking.details")}</p>
                                    <label>
                                        {t("activityBooking.serviceName")} <span>{props.updateReservationDetails.serviceName || props.updateReservationDetails.lines[0].serviceName || ''}</span>
                                    </label>
                                    <label>
                                        {t("activityBooking.locationName")}{" "}
                                        <span>{props.updateReservationDetails.locationName || ''} </span>
                                    </label>
                                    <label>
                                        {t("activityBooking.therapist")}{" "}
                                        <span>
                                            {props.updateReservationDetails.lines[0].technician.fullNameDisplayed || ''}
                                        </span>
                                    </label>



                                    {props.updateReservationDetails.lines[0].technician.gender && ['M', 'F'].includes(props.updateReservationDetails.lines[0].technician.gender) &&
                                        <label>
                                            {t("activityBooking.therapist_gender")}{" "}
                                            <span>
                                                {props.updateReservationDetails.lines[0].technician.gender == 'F' ? "Female" : "Male"}
                                            </span>
                                        </label>
                                    }


                                    {/* {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0]
                                        &&
                                        <label>
                                            {t("activityBooking.base_price")}{" "}
                                            <span>
                                                {`${props.currencyCode} ${props.updateReservationDetails.lines[0].price}`}
                                            </span>
                                        </label>
                                    } */}



                                    {/* {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].technician
                                        &&
                                        <label>
                                            {t("activityBooking.therapist_cost")}{" "}
                                            <span>
                                                {`${props.currencyCode} ${props.updateReservationDetails.lines[0].technician.price}`}
                                            </span>
                                        </label>
                                    } */}



                                    {/* {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].technician
                                        &&
                                        <label>
                                            {t("activityBooking.total_price")}{" "}
                                            <span>
                                                {`${props.currencyCode} ${props.updateReservationDetails.lines[0].price + props.updateReservationDetails.lines[0].technician.price}`}
                                            </span>
                                        </label>
                                    } */}







                                    {props.updateReservationDetails.customerNotes &&
                                        <label>
                                            {t("activityBooking.guest_notes")}{" "}
                                            <span>
                                                {props.updateReservationDetails.customerNotes}
                                            </span>
                                        </label>
                                    }

                                    {
                                        props.updateReservationDetails.totalGuests &&
                                        <label>
                                            {t("activityBooking.totalGuests")}{" "}
                                            <span>
                                                {props.updateReservationDetails.totalGuests}
                                            </span>
                                        </label>
                                    }

                                    
                                     


                                     

                                </div>



                            </form>
                        </div>
                    </div>
                </div>

                {isUpdatingReservation &&
                <div class="row">
                    <div class="col">
                        <div class="detail-body stay-body">
                            
                          
                           
                                <form>
                                     

                                    

                                    <div class="form-row  ">
                                        <p class="heading">{t("activityBooking.additional_guests_heading")}<span style={{ color: "red" }}>*</span></p>
                                        <p class="sub-heading">{t("activityBooking.additional_guests_subheading")}</p>
                                        

                                        <div class="qty-input">

                                           <input   type="text"  value={additionalGuestCount}   onChange={(event) => { console.log(event.target.value); setAdditionalGuestCount(event.target.value) }} />
                                            <button disabled={isNaN(Number(additionalGuestCount))} onClick={(e) => { e.preventDefault(); setAdditionalGuestCount(String(Number(additionalGuestCount) + 1)) }}>+</button>
                                            <button disabled={isNaN(Number(additionalGuestCount)) || Number(additionalGuestCount) <= 1} onClick={(e) => { e.preventDefault(); setAdditionalGuestCount(String(Number(additionalGuestCount) - 1)) }}>-</button>

                                        </div>


                                    </div>

                                </form>



                        </div>
                    </div>
                </div>

                }


                <div class="row">
                    <div class="form-controls">
                        <button onClick={handleNext}>
                            {isUpdatingReservation ? t("activityBooking.confirm_update_button") : t("activityBooking.edit_reservation_button")}
                        </button>
                        <button onClick={props.handleGoBack}>{t("activityBooking.back")}</button>
                    </div>
                </div>
            </section>

            {
                showLoader && <Loader displayMsg={t("activityBooking.loader_msg.updateMyActivity")} /> // check whether to show close button, 
            }
             




        </>
    )
}
const mapStateToProps = (state) => {
    return {
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
        , dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : "",
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        
        
        
         
    }
    }

export default connect(mapStateToProps, { setGoHome, sendAnalytics, popupOpenClose})(withTranslation("translations")(ActivityBookingUpdate));


{/* Page=1 ->  See booking details overview*/ }
{/* {currentPage == 1 && <ActivityBookingUpdate1 next={next} updateReservationDetails={props.updateReservationDetails} handleGoBack={handleGoBack} />} */ }

{/* Page=2 -> add details like additional guests to add */ }
{/* {currentPage == 2 && <ActivityBookingUpdate2 next={next} updateReservationDetails={props.updateReservationDetails} handleGoBack={handleGoBack}/>} */ }
